"use client";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CustomTip from "../../common/CustomTip";
import { useEffect, useMemo, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { BACKEND_API, TELEGRAM_API_BASE_URL } from "../../utils/constant";
import useApiServices from "../../utils/useApiServices";
import AddAdminGroup from "./Modals/AddAdmiGroup";
import swal from "sweetalert";
import styles from "../Tools/Component/MerchantGroupForm.module.css";

const _initialFormData = {
  // createdAt: new Date().toISOString(),
  createdBy: "",
  groupChatId: "",
  groupDescription: "",
  groupName: "",
  groupType: "",
  // isActive: true,
  // updatedAt: new Date().toISOString(),
};

function Admingroup({ toggleRightBar }) {
  const [opendminGroup, setOpenAdminGroup] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({ ..._initialFormData });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [merchantGroups, setMerchantGroups] = useState([]);

  const { apiCallFnforPost, apiCallFnforGet, apiCallFnforPut } =
    useApiServices();

  const fetchAdminGroups = async () => {
    try {
      const response = await apiCallFnforGet(
        `${TELEGRAM_API_BASE_URL}/admin-group/getAll`
      );
      console.log("response", response);
      if (response?.status === "success") {
        setMerchantGroups(response?.data);
      }
    } catch (err) {
      console.error("Error fetching merchant groups:", err);
    }
  };

  useEffect(() => {
    fetchAdminGroups();
  }, []);

  const handleChange = (e) => {
    try {
      const { name, value, type, checked } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    } catch (error) {
      console.log(`ERROR WHILE HANDLE CHANGE: ${error}`);
    }
  };

  const validateAdminGroup = (data, isEdit = false) => {
    const errors = {};
    if (!isEdit && !data?.createdBy?.trim())
      errors.createdBy = "Created By is required";
    if (!data?.groupChatId?.trim())
      errors.groupChatId = "Group chat ID is required";
    if (!data?.groupDescription?.trim())
      errors.groupDescription = "Group description is required";
    if (!data?.groupName?.trim()) errors.groupName = "Group name is required";
    if (!data?.groupType?.trim()) errors.groupType = "Group type is required";

    // if (!isEdit && !data?.mid?.trim()) errors.mid = "Merchant ID is required";
    // if (!isEdit && !data?.createdBy?.trim())
    //   errors.createdBy = "Created by is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddGroup = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);
    if (!validateAdminGroup(formData)) {
      setIsSubmitting(false);
      return;
    }

    try {
      const res = await apiCallFnforPost(
        `${BACKEND_API}/TelegramBot/admin-group/add`,
        formData
      );

      if (res?.statusCode === 201) {
        swal({
          title: "Success",
          text: "Admin group added successfully!",
          icon: "success",
        });
        setFormData({ ..._initialFormData });
        setFormErrors({});
        setOpenAdminGroup(false);
        fetchAdminGroups();
      } else {
        swal({
          title: "Error",
          text: res?.data?.message || "Failed to add admin group.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Network or server error:", error);
      swal({
        title: "Error",
        text: "Something went wrong. Please try again later.",
        icon: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditGroup = async () => {
    setIsSubmitting(true);
    if (!validateAdminGroup(formData, true)) {
      setIsSubmitting(false);
      return;
    }
    try {
      const payload = {
        groupChatId: formData?.groupChatId,
        groupDescription: formData?.groupDescription,
        editGroupName: formData?.groupName,
        editGroupType: formData?.groupType,
        editMid: formData?.mid,
        isActive: true,
      };
      const response = await apiCallFnforPut(
        `${TELEGRAM_API_BASE_URL}/admin-group/edit/${formData?.oldGroupId}`,
        payload
      );
      if (response?.status === "success") {
        swal({
          title: "Success!",
          text: response?.message || "Admin Group Updated Successfully!",
          icon: "success",
        });
        handleCloseModal();
        fetchAdminGroups();
      } else {
        swal({
          title: "Failed!",
          text: response?.message || "Failed to update merchant group",
          icon: "error",
        });
      }
    } catch (err) {
      console.log("Error updating admin group:", err);
      swal({
        title: "Failed!",
        text: err?.response?.message || "An error occurred while updating",
        icon: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setOpenAdminGroup(false);
    setFormErrors({});
    setFormData({ ..._initialFormData });
  };

  const openEditModal = (group) => {
    setFormData({
      groupChatId: group?.groupChatId,
      groupName: group?.groupName,
      groupDescription: group?.groupDescription,
      groupType: group?.groupType,
      oldGroupId: group?.groupChatId,
    });
    setIsEditing(true);
    setOpenAdminGroup(true);
  };

  const handleDeleteGroup = async (group) => {
    try {
      const response = await apiCallFnforPut(
        `${TELEGRAM_API_BASE_URL}admin-group/deactivate/${group?.groupChatId}`
      );

      if (response?.statusCode === 200) {
        swal({
          title: "Success",
          text: "Admin Group Deleted Successfully!",
          icon: "success",
        });
        // closeEditModal();
        fetchAdminGroups();
      } else {
        swal({
          title: "Failed",
          text: response?.message,
          icon: "error",
        });
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: "Failed To delete Admin Group.",
        icon: "error",
      });
      console.error("Error deleting admin group:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const columns = useMemo(
    () => [
      { headerName: "Id", field: "id", minWidth: 150, flex: 1 },
      { headerName: "Group Name", field: "groupName", minWidth: 150, flex: 1 },
      { headerName: "Chat ID", field: "groupChatId", minWidth: 150, flex: 1 },
      { headerName: "Type", field: "groupType", minWidth: 150, flex: 1 },
      {
        headerName: "Status",
        field: "isActive",
        minWidth: 120,
        renderCell: (params) => (
          <span
            className={`${styles.statusBadge} ${
              params?.value ? styles.active : styles.inactive
            }`}
          >
            {params?.value ? "Active" : "Inactive"}
          </span>
        ),
      },
      {
        headerName: "Action",
        field: "action",
        minWidth: 180,
        renderCell: (params) => {
          const group = params.row;
          return (
            <div className="flex gap-2 center">
              <button
                className="btn btn-sm btn-primary"
                onClick={() => openEditModal(group)}
              >
                Edit
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => handleDeleteGroup(group)}
              >
                Delete
              </button>
            </div>
          );
        },
      },
    ],
    [isSubmitting]
  );

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between bg-white">
        <div className="d-flex justify-content-start al ign-items-center">
          <button
            type="button"
            className="btn-close m-3"
            onClick={toggleRightBar}
          ></button>
          <div className="fs-2 text-dark fw-bold">Admin Group</div>
        </div>

        <div className="d-flex gap-2 justify-content-end me-2 mt-3 mb-2">
          <div className="d-flex gap-2 justify-content-end mt-4 me-4">
            <CustomTip size="18" placement="top" title="Add Admin Group">
              <div className="">
                <PersonAddAlt1Icon
                  onClick={() => {
                    setOpenAdminGroup(true);
                  }}
                  style={{ cursor: "pointer" }}
                  fontSize="large"
                />
              </div>
            </CustomTip>
          </div>
        </div>
      </div>

      {/* Data Table */}
      <div className="flex-grow-1 mb-5">
        <DataGrid
          rows={merchantGroups}
          columns={columns}
          getRowId={(row) => row?.id}
          slots={{
            toolbar: GridToolbar,
          }}
          slotProps={{
            toolbar: { showQuickFilter: true },
          }}
          disableRowSelectionOnClick
          autoHeight
          loading={isSubmitting}
          hideFooter
        />
      </div>

      {/* ADD ADMIN DIALOG  */}
      <AddAdminGroup
        formData={formData}
        formErrors={formErrors}
        open={opendminGroup}
        isEditing={isEditing}
        onHandleClose={handleCloseModal}
        // handleSubmit={handleAddGroup}
        handleSubmit={() => {
          if (isEditing) {
            handleEditGroup();
          } else {
            handleAddGroup();
          }
        }}
        handleChange={handleChange}
        isSubmitting={isSubmitting}
      />
    </div>
  );
}

export default Admingroup;
